import { render, staticRenderFns } from "./vis-device-state-history-detail-shift-productivity.vue?vue&type=template&id=1019b60a&"
import script from "./vis-device-state-history-detail-shift-productivity.vue?vue&type=script&lang=js&"
export * from "./vis-device-state-history-detail-shift-productivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports